import React from 'react';

import styled from 'styled-components';

import { H3, P } from 'stile-shared/src/components/2020/common/Primitives';
import { Column } from 'stile-shared/src/components/2020/layout/Column';
import { Grid } from 'stile-shared/src/components/2024/layout/Grid';

import { IconBullet } from '../IconBullet';

const StyledDiv = styled.div`
  background-color: var(--white);
  .content {
    padding: 60px 0 80px;

    @media (max-width: 768px) {
      margin: 0 25px;
      padding: 0 0 60px;
    }

    .grid-layout {
      .left,
      .right {
        position: relative;

        h2,
        p {
          padding: 0;
          margin: 0;
          margin-bottom: var(--space-l);
        }

        @media (max-width: 768px) {
          h2 {
            margin-bottom: 16px;
          }

          .description {
            margin-bottom: 28px;
          }
        }
      }
      .left {
        grid-column: 1 / span 6;

        @media (max-width: 768px) {
          grid-column: 1 / span 12;
        }
      }
      .right {
        grid-column: 8 / span 5;

        @media (max-width: 768px) {
          grid-column: 1 / span 12;
          grid-row: 2;
        }
      }
    }
  }

  .bottom-border {
    width: 100%;
    height: 1px;
    background-color: var(--stile-green-1);
    margin-top: 80px;

    @media (max-width: 768px) {
      margin-top: 60px;
    }
  }
`;

interface IconBulletData {
  iconSrc: React.ReactNode;
  title: string;
  text: string | React.ReactNode;
}

type PedagogyHeaderProps = {
  title: string;
  description: string;
  iconBullets: IconBulletData[];
} & React.HTMLAttributes<HTMLDivElement>;

export default function PedagogyHeader({
  title,
  description,
  iconBullets,
  ...props
}: PedagogyHeaderProps) {
  return (
    <StyledDiv {...props}>
      <div className="content">
        <Grid>
          <div className="left">
            <h2>{title}</h2>
            <div className="description">{description}</div>
          </div>
          <div className="right">
            <Column space="var(--space-l)">
              {iconBullets.map((bullet, index) => (
                <IconBullet
                  key={index}
                  iconSrc={bullet.iconSrc}
                  title={bullet.title}
                  text={bullet.text}
                />
              ))}
            </Column>
          </div>
        </Grid>
        <div className="bottom-border" />
      </div>
    </StyledDiv>
  );
}
